/**
 * Case Sheet Access API.
 *
 * Talks to the new `case_sheet_access/` backend module (department ↔ case
 * sheet visibility). Used by the admin CaseSheetAccessManager screen and by
 * useCaseSheetPermission (Case Sheet tab filtering).
 */

import axios from "../../login/Axios-interceptor";

const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
const API_BASE = `${REACT_APP_BACKEND_ROUTE_URL}case_sheet_access/`;

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("accessToken") || "";
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    "App-Mode":
      sessionStorage.getItem("APP_MODE") ||
      sessionStorage.getItem("appMode") ||
      "",
    "Org-Code":
      sessionStorage.getItem("ORG_CODE") ||
      sessionStorage.getItem("orgCode") ||
      "",
    Username:
      sessionStorage.getItem("userName") ||
      sessionStorage.getItem("username") ||
      "",
    "User-Access-Key":
      sessionStorage.getItem("USER_ACCESS_KEY") ||
      sessionStorage.getItem("accessKey") ||
      "",
  };
};

const unwrapResponse = (response) => {
  const data = response?.data;
  if (data?.status === "Failed") {
    const err = new Error(data.message || "Case sheet access request failed");
    err.status = response?.status;
    throw err;
  }
  return data;
};

/** Admin screen: current tagging for one department (defaults filled in for untagged codes). */
export const fetchCaseSheetAccess = async (departmentId) => {
  const response = await axios.get(API_BASE, {
    params: { department_id: departmentId },
    headers: getAuthHeaders(),
  });
  return unwrapResponse(response);
};

/** Admin screen: upserts the 6 case-sheet flags for one department. */
export const saveCaseSheetAccess = async (departmentId, caseSheets) => {
  const response = await axios.post(
    API_BASE,
    { department_id: departmentId, case_sheets: caseSheets },
    { headers: getAuthHeaders() },
  );
  return unwrapResponse(response);
};

/**
 * Case Sheet Modal: the 6-flag table for the logged-in doctor / facility user.
 *
 * `doctorId` (DoctorRecord.doctor_id, the business code) is optional. Without
 * it the backend resolves the caller — a doctor gets their own department's
 * table, a facility user gets the unfiltered default. Facility users pass the
 * doctor whose appointment is open so they see that doctor's department table.
 */
export const fetchCaseSheetPermissionForUser = async (doctorId) => {
  const response = await axios.get(`${API_BASE}for_user/`, {
    params: doctorId ? { doctor_id: doctorId } : undefined,
    headers: getAuthHeaders(),
  });
  return unwrapResponse(response);
};
